import React, { useEffect, useState } from 'react';
import LeftControl from '../../../Components/LeftControl';
import PageHeader from '../../../Components/PageHeader';
import { Grid } from '@material-ui/core';
import { Button, Modal, message, Form, Select } from 'antd';
import AddWoForm from './Forms/AddWoForm';
import TicketForm from './Forms/TicketForm';
import { AddWoFormApi, TicketFormApi } from '../../../Services/LocomotiveServices';
import { createPayroll, deletePayrollUser, get_ticket_type_listing, getAllPayroll } from '../../../Services/employee';
import PageLayout from '../../../Components/LayoutComponents/PageLayout';
import { PlusOutlined } from '@ant-design/icons';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import { DeleteOutline } from '@material-ui/icons';
import services from '../../../Services';

const SystemAdminPage = () => {
    const [form] = Form.useForm(); // Hook for accessing the form instance
    const [form_3] = Form.useForm()
    const [id, setId] = useState('')
    const [payrollData, setPayrollData] = useState([])
    const [userData, setUserData] = useState([])
    const [modal, setModal] = useState({
        add: false,
        list: false,
        delete: false
    })
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleTicket, setIsModalVisibleTicket] = useState(false);
    const [types, setTypes] = useState([])
    const { employee } = services;

    const handleModal = (modalName, id) => {
        if (id) setId(id)
        setModal((prev) => { return { ...prev, [modalName]: !modal[modalName] } })
    }
    const fetchTypes = async () => {
        try {
            const typesData = await get_ticket_type_listing();
            const names = typesData?.data?.map(type => ({ id: type?.id, name: type?.name }));
            setTypes(names)
        } catch (error) {
            console.error('Error fetching types:', error);
        }
    };

    const handleOpenModal = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    const handleOpenModalTicket = async () => {
        await fetchTypes();
        setIsModalVisibleTicket(true);
    };

    const handleCloseModalTicket = () => {
        setIsModalVisibleTicket(false);
    };

    const handleSubmit = async (formData) => {
        try {

            const response = await AddWoFormApi(formData);
            message.success('Sucessfully Submitted')
            setIsModalVisible(false)


        } catch (error) {
            console.error('Error submitting form data:', error);
        }
    };

    const handleSubmitTicketForm = async (formData) => {

        try {

            const response = await TicketFormApi(formData);
            message.success('Sucessfully Submitted')
            setIsModalVisibleTicket(false)

            form.resetFields();
        } catch (error) {
            console.error('Error submitting form data:', error);
        }
    };
    const getAllEmployees = async () => {
        let result = await employee.get_employee_listing_not_Terminated({});
        let data = result?.data?.map((item, index) => {
            return {
                value: item?.id,
                label: `${item?.firstName} ${item?.lastName}`,
            }
        })
        setUserData(data)
    }

    const getPayrolls = async () => {
        const result = await getAllPayroll()
        setPayrollData(result?.data)
    }
    const handleCreatePayroll = async (val) => {
        
        const result = await createPayroll(val)
        if (result?.httpStatus == 200) {
            message?.success('Employee Addedd Successfully!')
            handleModal('add')
            form_3?.resetFields()
            getPayrolls()
        }
    }
    const deleteUser = async () => {
        const result = await deletePayrollUser(id)

        if (result?.httpStatus == 200) {
            message?.success('Employee Deleted Successfully!')
            handleModal('delete')
            getPayrolls()
        }
    }
    const TableData = {
        header: ['Name', 'Email', <p style={{ textAlign: "end", marginRight: "10px" }}>Action</p>],
        rows: payrollData?.map(row => [
            `${row?.employee?.firstName} ${row?.employee?.lastName}`,
            row?.employee?.email || 'N-A',
            <div style={{ display: "flex", justifyContent: "end", marginRight: "10px" }}>
                <Button onClick={() => { handleModal('delete', row?.id) }} style={{
                    color: "red", margin: "0px",
                    border: "none", padding: "0px", fontSize: "9px"
                }}><DeleteOutline /></Button>
            </div>
        ])
    }
    useEffect(() => {
        getPayrolls()
        getAllEmployees()
    }, [])
    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">System Admin</Grid>
                <Grid style={{ marginTop: '10px' }}>
                    <Button style={{ background: '#2963AD', color: 'white', width: '200px' }} onClick={handleOpenModal}>Add WO Task</Button>
                    <Modal
                        title="Add WO Task"
                        visible={isModalVisible}
                        onOk={handleCloseModal}
                        onCancel={handleCloseModal}
                        footer={false}
                    >
                        <AddWoForm onSubmit={handleSubmit} />
                    </Modal>
                    <Button style={{ background: '#2963AD', color: 'white', width: '200px', marginLeft: '5px' }} onClick={handleOpenModalTicket}>Add Ticket Category</Button>
                    <Modal
                        title="Add Ticket Category"
                        visible={isModalVisibleTicket}
                        onOk={handleCloseModalTicket}
                        onCancel={handleCloseModalTicket}
                        footer={false}
                    >
                        <TicketForm types={types} handleTicketForm={handleSubmitTicketForm} form={form} />
                    </Modal>
                    <Button style={{ background: '#2963AD', color: 'white', width: '200px' }} onClick={() => { handleModal('list') }}> Payroll Approver</Button>
                    {/* Delete Employee ---> */}
                    <Modal
                        title="Delete Employee"
                        open={modal?.delete}
                        footer={false}
                        onCancel={() => handleModal('delete')}>
                        <>
                            <p>Are you sure you want to delete this employee?</p>
                            <Button style={{
                                backgroundColor: 'red',  // Light reddish color
                                color: 'white',
                                width: "100%",
                                border: "none"
                            }}
                                onClick={deleteUser}>
                                Delete </Button>
                        </>
                    </Modal>
                    {/* Employee Listing */}
                    <Modal
                        title="Payroll Approver"
                        open={modal?.list}
                        width={700}
                        footer={false}
                        onCancel={() => handleModal('list')}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: "end" }}>
                                <Button style={{ background: '#2963AD', color: 'white', marginBottom: "5px" }}
                                    onClick={() => {
                                        handleModal('add')
                                    }}> <PlusOutlined />Add Employee</Button>
                            </div>
                            <DynamicTable tableData={TableData} />
                        </div>
                    </Modal>
                    {/* Add New Employee---> */}
                    <Modal
                        title="Add New Employee"
                        open={modal?.add}
                        footer={false}
                        onCancel={() => {
                            handleModal('add'); // Close the modal
                            form_3.resetFields(); // Reset the form to default values when modal is closed
                        }}                        >
                        <Form form={form_3} onFinish={handleCreatePayroll}>
                            <Form.Item
                                name="UserId"
                                label="Employee"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Employee is required!'
                                    },
                                ]}>
                                <Select
                                    allowClear={true}
                                    style={{
                                        width: "100%",
                                    }}
                                    options={userData}
                                    optionFilterProp="label"
placeholder='select value'
                                    showSearch
                                />
                            </Form.Item>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button style={{ background: '#2963AD', color: 'white', width: "100%" }} htmlType='submit'>Submit</Button>
                            </div>
                        </Form>
                    </Modal>
                </Grid>
                <Grid style={{ marginTop: '10px' }}>

                </Grid>
            </Grid>
        </PageLayout>
    );
}

export default SystemAdminPage;
